import {
  useActiveAccount,
  useActiveAccountLogo,
  useActiveTrial,
} from '@witmetrics/data-store';
import { DIALOGS } from '@witmetrics/unison-core';
import { getEnv } from '@witmetrics/utils/env';
import { NODE_ENV } from '@witmetrics/utils/constants';
import { API } from '@/api';
import { getAuthUrl } from '@/api/urls';
import { showErrorToaster } from '@/utils/toasters';
import { isActiveTrial } from '@/utils/trials';
import { useAppState } from '@/providers/AppStateProvider';
import HeaderLogo from '@/components/HeaderLogo';
import Tooltip from '@/components/Tooltip';
import IconButton from '@/components/IconButton';
import { AddIcon, SearchIcon } from '@/icons';
import PlatformSelector from './PlatformSelector';
import UserMenu from './UserMenu';
import CreditsBalance from './CreditsBalance';
import Notifications from './Notifications';
import PendingServices from './PendingServices';
import TrialCountdown from './TrialCountdown';
import { classes, getActiveLogoUrl } from './utils';

export default function AppHeader() {
  const { onOpenDialog } = useAppState();
  const activeAccount = useActiveAccount();
  const activeTrial = useActiveTrial();
  const logoValue = useActiveAccountLogo();
  const logo = getActiveLogoUrl(activeAccount?.accountType, logoValue);

  const handleOpenShortcuts = () => onOpenDialog(DIALOGS.SHORTCUTS);

  const handleOpenSearch = () => onOpenDialog(DIALOGS.SEARCH);

  const handleLogout = async () => {
    try {
      await API.Users.logout();
      // @ts-ignore
      window.location = `${getAuthUrl()}/login`;
    } catch (err) {
      showErrorToaster('Error logging out');
      throw err;
    }
  };

  return (
    <header className={classes.header}>
      <HeaderLogo src={logo || null} />
      <button
        className={classes.search}
        aria-label="search"
        onClick={handleOpenSearch}>
        <SearchIcon className={classes.searchIcon} />
        <span>Search cases, patients…</span>
      </button>
      {getEnv() === NODE_ENV.TESTING && (
        <div className={classes.testingWrapper}>
          <span>This is a testing version of witMetrics.</span>
          <a
            className={classes.testingLink}
            href="https://unison.witmetrics.io/">
            Go to main site
          </a>
        </div>
      )}
      <div className={classes.spacer} />
      <TrialCountdown />
      <CreditsBalance />
      <Notifications className={classes.iconButton} />
      <PendingServices className={classes.iconButton} />
      <div className={classes.addButtonWrapper}>
        <Tooltip arrow enterDelay={0} placement="bottom" title="Shortcuts">
          <IconButton
            className={classes.addButton}
            aria-label="shortcuts"
            onClick={handleOpenShortcuts}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      </div>
      <div className={classes.divider} />
      <PlatformSelector isStatic={isActiveTrial(activeTrial)} />
      <div className={classes.divider} />
      <UserMenu onLogout={handleLogout} />
    </header>
  );
}
